import React from 'react';

import { Box, Typography, Grid, CircularProgress, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { Pages } from 'src/common/constants/Pages';
import { useUserRole } from 'src/common/hooks/useUserRole';
import { UserRoles } from 'src/common/types/User';

import { useGetUserQuery } from '../../../common/apis/AdminApi';
import { ReactComponent as ChevronLeftIconBlue } from '../../../common/assets/icons/chevron_left_icon_blue.svg';
import UserCodesContainer from '../../../common/components/UserCodesContainer/UserCodesContainer';
import { useClientRect } from '../../../common/hooks/useClientRect';

import UserContainer from './components/UserContainer';
import UserInfoContainer from './components/UserInfoContainer';
import UserLogContainer from './components/UserLogContainer/UserLogContainer';

import './UserProfileScreen.scss';

import AthenaUsernameBox from './components/AthenaUsernameBox';

const UserProfileScreen: React.FC = () => {
  const [rect, ref] = useClientRect();
  const navigate = useNavigate();
  const height = rect ? (rect as unknown as DOMRect).height : 0;
  const { id: userId } = useParams();
  const { data: user, isLoading } = useGetUserQuery(userId ?? '', {
    skip: !!!userId,
  });

  const { userRole } = useUserRole();

  if (isLoading) {
    return (
      <Box className='user-screen-content-wrapper'>
        <CircularProgress
          color='primary'
          size='48px'
          style={{ alignSelf: 'center', justifySelf: 'center', marginTop: 64 }}
        />
      </Box>
    );
  }

  if (!!!user) {
    return (
      <Box className='center' sx={{ textAlign: 'center', marginTop: 40 }}>
        <Typography variant='h4'>
          You are not authorized to access this user.
        </Typography>
      </Box>
    );
  }

  return (
    <Box className='user-screen-content-wrapper'>
      <Button
        disabled={isLoading}
        sx={{
          marginBottom: '32px',
        }}
        onClick={() =>
          window.history.state && window.history.state.idx > 0
            ? navigate(-1)
            : navigate(Pages.users)
        }
        color={'darkBlue'}
        variant={'text'}
        startIcon={<ChevronLeftIconBlue />}
      >
        Back
      </Button>

      <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} direction='row'>
        <Grid item xs={10} sm={10} lg={4} xl={3}>
          <Box ref={ref}>
            <UserContainer user={user} style={{ marginBottom: '20px' }} />
            <AthenaUsernameBox user={user} />
            {userRole === UserRoles.SUPER_ADMIN && (
              <UserInfoContainer user={user} />
            )}
          </Box>
        </Grid>
        <Grid item xs={10} sm={10} lg={4} xl={5}>
          <UserCodesContainer type='admin' user={user} height={height} />
        </Grid>
        <Grid item xs={10} sm={10} lg={4} xl={4}>
          <Box
            style={{
              height: height,
            }}
          >
            <UserLogContainer
              user={user}
              style={{
                height:
                  userRole === UserRoles.SUPER_ADMIN
                    ? (height - 16) / 2
                    : height,
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserProfileScreen;
